import type { JSX } from 'react'

import {
  DropdownMenu,
  MoonIcon,
  MonitorIcon,
  SlidersVerticalIcon,
  SunIcon,
  WandSparklesIcon,
  useTheme,
} from '@buffer-mono/popcorn'

import { useShouldShowMocktail } from '~publish/mocktail'

type ThemeValue = 'light' | 'dark' | 'system'

const themeOptions: { value: ThemeValue; label: string; icon: JSX.Element }[] =
  [
    { value: 'light', label: 'Light', icon: <SunIcon size="small" /> },
    { value: 'dark', label: 'Dark', icon: <MoonIcon size="small" /> },
    { value: 'system', label: 'System', icon: <MonitorIcon size="small" /> },
  ]

export function InternalToolsSubMenu({
  subMenuClassName,
  onSelectMocktail,
}: {
  subMenuClassName?: string
  onSelectMocktail: () => void
}): JSX.Element {
  const { theme, setTheme } = useTheme()
  const shouldShowMocktail = useShouldShowMocktail()

  const handleThemeChange = (value: string): void => {
    if (value === 'light' || value === 'dark' || value === 'system') {
      setTheme(value)
    }
  }

  return (
    <>
      <DropdownMenu.Separator />
      <DropdownMenu.Sub>
        <DropdownMenu.SubTrigger>
          <SlidersVerticalIcon size="small" />
          Internal Tools
        </DropdownMenu.SubTrigger>
        <DropdownMenu.SubMenu className={subMenuClassName}>
          <DropdownMenu.Group label="Color Mode">
            <DropdownMenu.RadioGroup value={theme} onChange={handleThemeChange}>
              {themeOptions.map((option) => (
                <DropdownMenu.RadioItem key={option.value} value={option.value}>
                  {option.icon}
                  {option.label}
                </DropdownMenu.RadioItem>
              ))}
            </DropdownMenu.RadioGroup>
          </DropdownMenu.Group>
          {shouldShowMocktail && (
            <>
              <DropdownMenu.Separator />
              <DropdownMenu.Item onSelect={onSelectMocktail}>
                <WandSparklesIcon size="small" />
                Mocktail
              </DropdownMenu.Item>
            </>
          )}
        </DropdownMenu.SubMenu>
      </DropdownMenu.Sub>
    </>
  )
}
